import React from 'react';
import LinuxFilePermissionsInstructions from './LinuxFilePermissionsInstructions';
import BrokenWebServerRescueInstructions from './BrokenWebServerRescueInstructions';
import ServiceStartupFailuresInstructions from './ServiceStartupFailuresInstructions';
import DjangoApplicationDisasterInstructions from './DjangoApplicationDisasterInstructions';
import NextjsFullStackInstructions from './NextjsFullStackInstructions';
import WordPressBasicsInstructions from './WordPressBasicsInstructions';
import WordPressDatabaseConnectionFailureInstructions from './WordPressDatabaseConnectionFailureInstructions';
import MemoryManagementMayhemInstructions from './MemoryManagementMayhemInstructions';
import ReactNodeStackBreakdownInstructions from './ReactNodeStackBreakdownInstructions';
import DatabaseReplicationInstructions from './DatabaseReplicationInstructions';
import StorageMigrationScalingInstructions from './StorageMigrationScalingInstructions';
import BackupDisasterRecoveryInstructions from './BackupDisasterRecoveryInstructions';
import NginxSetupInstructions from './NginxSetupInstructions';
import SpacesBackupAutomationInstructions from './SpacesBackupAutomationInstructions';
import KubernetesMiniClusterInstructions from './KubernetesMiniClusterInstructions';
import BasicShellScriptingInstructions from './BasicShellScriptingInstructions';

interface EnhancedInstructionsProps {
  labSlug: string;
  instructions?: string;
}

export function EnhancedInstructions({ labSlug, instructions }: EnhancedInstructionsProps) {
  // Return the specialized component for linux-file-permissions-users lab
  if (labSlug === 'linux-file-permissions-users') {
    return <LinuxFilePermissionsInstructions />;
  }

  // Return the specialized component for broken-web-server-rescue lab
  if (labSlug === 'broken-web-server-rescue') {
    return <BrokenWebServerRescueInstructions />;
  }

  // Return the specialized component for service-startup-failures lab
  if (labSlug === 'service-startup-failures') {
    return <ServiceStartupFailuresInstructions />;
  }

  // Return the specialized component for django-application-disaster lab
  if (labSlug === 'django-application-disaster') {
    return <DjangoApplicationDisasterInstructions />;
  }

  // Return the specialized component for nextjs-fullstack lab
  if (labSlug === 'nextjs-fullstack') {
    return <NextjsFullStackInstructions />;
  }

  // Return the specialized component for wordpress-basics lab
  if (labSlug === 'wordpress-basics') {
    return <WordPressBasicsInstructions />;
  }

  // Return the specialized component for wordpress-database-connection-failure lab
  if (labSlug === 'wordpress-database-connection-failure') {
    return <WordPressDatabaseConnectionFailureInstructions />;
  }

  // Return the specialized component for memory-management-mayhem lab
  if (labSlug === 'memory-management-mayhem') {
    return <MemoryManagementMayhemInstructions />;
  }

  // Return the specialized component for react-node-stack-breakdown lab
  if (labSlug === 'react-node-stack-breakdown') {
    return <ReactNodeStackBreakdownInstructions />;
  }

  // Return the specialized component for database-replication lab
  if (labSlug === 'database-replication') {
    return <DatabaseReplicationInstructions />;
  }

  // Return the specialized component for k3s-mini-cluster lab
  if (labSlug === 'k3s-mini-cluster') {
    return <KubernetesMiniClusterInstructions />;
  }

  // Return the specialized component for storage-migration-scaling lab
  if (labSlug === 'storage-migration-scaling') {
    return <StorageMigrationScalingInstructions />;
  }

  // Return the specialized component for backup-disaster-recovery lab
  if (labSlug === 'backup-disaster-recovery') {
    return <BackupDisasterRecoveryInstructions />;
  }

  // Return the specialized component for basic-shell-scripting lab
  if (labSlug === 'basic-shell-scripting') {
    return <BasicShellScriptingInstructions />;
  }

  // Return the specialized component for nginx-setup lab
  if (labSlug === 'nginx-setup') {
    return <NginxSetupInstructions />;
  }

  // Return the specialized component for spaces-backup-automation lab
  if (labSlug === 'spaces-backup-automation') {
    return <SpacesBackupAutomationInstructions />;
  }

  // No generic instruction handler - all labs should have dedicated components
  return <p className="text-gray-400">No enhanced instructions available for this lab.</p>;
}
